import { render, staticRenderFns } from "./PaymentPlan.vue?vue&type=template&id=483094ef&"
import script from "./PaymentPlan.vue?vue&type=script&lang=js&"
export * from "./PaymentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports